import { deleteAlertsBulkActionType } from '../../../../../../backend/features/alerts';
import { useAlertConfig, useAlertStorageClient, useAlertUiTranslation } from '../../../../../../ui/hooks';
import { useAlertsUrl } from '../../../../../../ui/hooks/useAlertsUrl';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { MenuIconButton } from '@juvare/common-web-ui/MenuIconButton';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Divider, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useAlertServiceClient } from '../../../hooks';
import { showNotificationDialog } from '../../AlertDialog';
import { mapToAlertWizardFormData, showTemplateEditDialog } from '../../AlertDialog/Utils';
import { shareTemplateDialog } from '../../AlertsListTemplate/Components/ShareTemplateDialog';
export const AlertActionsTemplate = ({ data, onReload, onCloseDialog }) => {
    const { t } = useAlertUiTranslation();
    const alertsSentUrl = useAlertsUrl('sent');
    const userState = useUserState();
    const alertConfig = useAlertConfig();
    const alertServiceClient = useAlertServiceClient();
    const alertStorageClient = useAlertStorageClient();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        data.right === 'write' && (React.createElement(Tooltip, { title: t('common.edit') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showNotificationDialog({
                        alertId: data.id,
                        mode: 'template',
                        dialogStep: 'wizard',
                        reviewFormHeader: t('common.reviewAndSave'),
                        wizardHeader: t('pages.toolbar.template.edit'),
                        onSubmitSuccess: (_data, onClose) => {
                            onReload(false);
                            onClose();
                            onCloseDialog();
                        },
                    });
                } },
                React.createElement(EditOutlinedIcon, null)))),
        React.createElement(Tooltip, { title: t('common.reviewAndSend') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showNotificationDialog({
                        alertId: data.id,
                        mode: 'notification',
                        dialogStep: 'review',
                        reviewFormHeader: t('common.reviewAndSend'),
                        wizardHeader: t('common.editNotification'),
                        onSubmitSuccess: (_data, onClose) => {
                            onClose();
                            onCloseDialog();
                            navigationContext.navigate(() => navigate(alertsSentUrl));
                        },
                    });
                } },
                React.createElement(SendOutlinedIcon, null))),
        data.right === 'write' && (React.createElement(MenuIconButton, { "aria-label": t('common.moreActions'), icon: React.createElement(MoreHorizIcon, null), menuItems: [
                {
                    label: t('common.share'),
                    onClick: () => {
                        shareTemplateDialog({
                            data,
                            onSubmit: (alertFormData) => {
                                alertStorageClient
                                    .updateAlert(alertFormData)
                                    .then(() => {
                                    showAlertSnackbar({ type: 'success', message: t('common.templateShared') });
                                    onReload(false);
                                })
                                    .catch(handleErrorDialog);
                            },
                        });
                    },
                },
                {
                    label: t('common.delete'),
                    onClick: () => {
                        showConfirmDialog({
                            title: t('deleteTemplateAlertsDialog.title', { count: 1 }),
                            content: t('deleteTemplateAlertsDialog.message', { count: 1 }),
                            confirmLabel: t('common.delete'),
                            onConfirm: () => {
                                launchBulkAction({
                                    type: deleteAlertsBulkActionType,
                                    title: t('deleteTemplateAlertsDialog.progress', { count: 1 }),
                                    runSync: true,
                                    params: { alertIds: [data.id] },
                                    onClose: () => {
                                        onReload(true);
                                        onCloseDialog();
                                    },
                                });
                            },
                        });
                    },
                },
                {
                    label: t('common.manage'),
                    onClick: () => {
                        showTemplateEditDialog(mapToAlertWizardFormData(data, alertConfig, 'template'), userState, t, alertServiceClient, alertStorageClient, () => {
                            onReload(false);
                        });
                    },
                },
            ] })),
        React.createElement(Divider, { orientation: 'vertical', flexItem: true }),
        React.createElement(Tooltip, { title: data.pinned ? t('common.unpin') : t('common.pin') },
            React.createElement(IconButton, { sx: { alignSelf: 'center', mr: 1 }, color: 'primary', onClick: () => {
                    const alertPins = data.pinned ? [] : [{ type: 'user', externalId: userState.id }];
                    alertServiceClient
                        .pinAlert(data.id, alertPins)
                        .then(() => {
                        showAlertSnackbar({
                            type: 'success',
                            message: data.pinned ? t('pages.tables.templateUnpinned') : t('pages.tables.templatePinned'),
                        });
                        onReload(false);
                    })
                        .catch(handleErrorSnackbar);
                } }, data.pinned ? React.createElement(PushPinIcon, null) : React.createElement(PushPinOutlinedIcon, null)))));
};
